import script from "./header.vue?vue&type=script&setup=true&lang=js"
export * from "./header.vue?vue&type=script&setup=true&lang=js"

import "./header.vue?vue&type=style&index=0&id=4519dbb8&scoped=true&lang=scss"

import exportComponent from "E:\\guanwang\\zhongYuanGuanWang\\zhongyuanyuzhou_pc_vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4519dbb8"]])

export default __exports__